export enum VariableActionType {
  // Variable management
  GET_VARIABLE = 'GET_VARIABLE',
  SET_VARIABLE = 'SET_VARIABLE',
  VARIABLE_DETAIL_UPDATE = 'VARIABLE_DETAIL_UPDATE',
  VARIABLE_JSON_SCHEMA_UPDATE = 'VARIABLE_JSON_SCHEMA_UPDATE',
  UPDATE_VARIABLE_STATE = 'UPDATE_VARIABLE_STATE',
  UPDATE_VARIABLE_SUCCESS = 'UPDATE_VARIABLE_SUCCESS',
  UPDATE_VARIABLE_PRODUCT_ENTITY = 'UPDATE_VARIABLE_PRODUCT_ENTITY',
  UPDATE_VARIABLE_IS_VALID = 'UPDATE_VARIABLE_IS_VALID',
  SET_VARIABLE_DIFF = 'SET_VARIABLE_DIFF',
  DELETE_VARIABLE = 'DELETE_VARIABLE',
}
